export default class Synths {
  constructor (context) {
    this.context = context;
  }

  sine () {
    const osc = this.context.createOscillator();
    osc.frequency.setValueAtTime(1000, this.context.currentTime);
    return osc;
  }

  sawtooth () {
    const osc = this.context.createOscillator();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(1000, this.context.currentTime);
    return osc;
  }

  triangle () {
    const osc = this.context.createOscillator();
    osc.type = 'triangle';
    osc.frequency.setValueAtTime(1000, this.context.currentTime);
    return osc;
  }

  square () {
    const osc = this.context.createOscillator();
    osc.type = 'square';
    osc.frequency.setValueAtTime(1000, this.context.currentTime);
    return osc;
  }

  white () {
    const bufferSize = 2 * this.context.sampleRate;
    const noiseBuffer = this.context.createBuffer(1, bufferSize, this.context.sampleRate);
    const output = noiseBuffer.getChannelData(0);
    for (let i = 0; i < bufferSize; i++) {
      output[i] = Math.random() * 2 - 1;
    }

    const whiteNoise = this.context.createBufferSource();
    whiteNoise.buffer = noiseBuffer;
    whiteNoise.loop = true;
    return whiteNoise;
  }
}
